var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect, useRef } from 'react';
const isEditableTarget = (target) => {
    if (!(target instanceof HTMLElement)) {
        return false;
    }
    return (target.isContentEditable ||
        ['INPUT', 'SELECT', 'TEXTAREA'].includes(target.tagName));
};
const isMatch = (event, shortcut) => {
    const hasModifier = event.ctrlKey || event.metaKey;
    const isModifierMatch = shortcut.ctrlOrMeta ? hasModifier : !hasModifier;
    const isKeyMatch = event.key.toLowerCase() === shortcut.key.toLowerCase();
    const isBlockedInEditable = shortcut.ignoreWhenEditable && isEditableTarget(event.target);
    return isModifierMatch && isKeyMatch && !isBlockedInEditable;
};
// Registers global (window-level) keyboard shortcuts. Element-local shortcuts
// should be wired directly on their element (e.g. onKeyDown), not here.
export const useGlobalKeyboardShortcut = (shortcuts, { enabled = true } = {}) => {
    _react_refresh_temp_1();
    // Ref so an inline `shortcuts` array doesn't re-subscribe the listener each render.
    const shortcutsRef = useRef(shortcuts);
    shortcutsRef.current = shortcuts;
    useEffect(() => {
        if (!enabled) {
            return;
        }
        const onKeyDown = (event) => {
            // Browser autofill dispatches a plain Event for 'keydown', so `key`
            // can be absent at runtime though the DOM type declares it a string.
            // Such an event names no key, so it can match no shortcut.
            if (typeof event.key !== 'string') {
                return;
            }
            for (const shortcut of shortcutsRef.current) {
                if (isMatch(event, shortcut)) {
                    if (shortcut.preventDefault ?? true) {
                        event.preventDefault();
                    }
                    shortcut.onMatch(event);
                    break;
                }
            }
        };
        window.addEventListener('keydown', onKeyDown);
        return () => {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [enabled]);
};
_react_refresh_temp_1(useGlobalKeyboardShortcut, "MljVCiJFcZ6JH/I1K7xWyjaGWYs=");
